import { MocAssessmentModal } from './mocAssessmentModal'

export { MocAssessmentModal }
